/**
 * Update the router in this file instead of AppRoutes.js if you're working with embedded Angular.
 */

import "core-js/stable";
import "regenerator-runtime/runtime";

import "./config"; // has some side affects to window
// some legacy libraries need or at least really like to be installed to the global window
import "./globals.js";
// set up static / global stuff. A lot of this is legacy and would be nice if it was removed or re-organized
import "./components/index.scss";
import "./styles/highcharts-style";

import "./components/_charts.scss";

import "./styles/main.scss";
import "./styles/library-styles.scss";
import "./styles/css3.css";

import AppContainer from "./modules/app/AppContainer";
import ReactDOM from "react-dom";
import * as React from "react";
import UnrecoveredErrorHandler from "./modules/app/UnrecoveredErrorHandler";

const root = window.document.createElement("div");
root.style.height = "100%";
window.document.body.appendChild(root);

ReactDOM.render(
  <UnrecoveredErrorHandler>
    <AppContainer />
  </UnrecoveredErrorHandler>,
  root
);
